import React, { useState, useCallback } from 'react';
import OtpInput from 'react-otp-input';
import PropTypes from 'prop-types';
import Button from 'partial/components/Button';
import SVG from 'react-inlinesvg';
import { ModalCard, useCreateModal } from 'partial/components/Modal';
import { useMfaSetup, useQR } from 'modules/mfa/hooks';
import classNames from 'classnames';

export const useMFA = () => {
  const createModal = useCreateModal();

  const openMFA = useCallback(
    (data) => {
      createModal({
        content: (close) => <MFA onClose={close} data={data} />,
      });
    },
    [createModal],
  );

  return openMFA;
};

function MFA({ onClose, data }) {
  const callback = () => {
    onClose();
    data();
  };
  const type = 'enable';
  const [, qr_code] = useQR();

  const [state, setState] = useState({ otp: '' });
  const [isUpdating, action] = useMfaSetup(callback);

  const submit = () => {
    action({ type, ...state });
  };

  const handleChange = (val) => {
    setState({ otp: val });
  };

  return (
    <ModalCard size="md" onClose={onClose}>
      <div className="px-8 pb-8 max-h-[90vh] overflow-y-auto">
        <h4 className="heading-4 text-gray-800 uppercase mb-6">
          Multi-factor Authentication
        </h4>
        {/* <Form onSubmit={handleSubmit} error={errors}> */}
        <div className="space-y-3">
          <div>
            <p>
              1. Install a compatible app on your mobile device or computer.
            </p>
            <ul className="list-disc mx-8 my-2">
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                  className="text-primary font-semibold"
                  target="_blank"
                  rel="noreferrer"
                >
                  Google Authenticator (Android)
                </a>
              </li>
              <li>
                <a
                  href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                  className="text-primary font-semibold"
                  target="_blank"
                  rel="noreferrer"
                >
                  Google Authenticator (IOS)
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p>2. Scan this QR code using your MFA app.</p>
            <div className="flex items-center justify-center">
              <SVG
                src={qr_code?.data}
                width={250}
                height="auto"
                title="React"
              />
            </div>
          </div>
          <div className="space-y-4">
            <p>3. Please enter MFA PIN below:</p>
            <div className="px-4">
              <OtpInput
                shouldAutoFocus
                inputType="tel"
                containerStyle="w-full gap-4 sm:px-10"
                value={state?.otp}
                onChange={handleChange}
                numInputs={6}
                renderInput={(props) => (
                  <input
                    {...props}
                    className={classNames(
                      'text-gray-700 font-bold text-lg flex-1 rounded border border-light-gray-300 !w-full h-8 sm:h-14',
                    )}
                  />
                )}
              />
            </div>
          </div>
          <div className="bg-red-200 text-[#7B2C10] rounded p-4 font-semibold">
            Important: Make sure NOT to uninstall your authenticator app or
            remove the Txtbox account in your authenticator app. You will not be
            able to login without the PIN while MFA is enabled.
          </div>
        </div>

        <div className="flex flex-col gap-2 mt-6 sm:mt-8">
          <Button
            primary
            className="uppercase w-full"
            disabled={isUpdating}
            onClick={submit}
          >
            submit
          </Button>
          <Button outline onClick={onClose} className="uppercase w-full">
            cancel
          </Button>
        </div>
        {/* </Form> */}
      </div>
    </ModalCard>
  );
}

MFA.propTypes = {
  onClose: PropTypes.func.isRequired,
  data: PropTypes.func.isRequired,
};

export default MFA;
